import { DefaultErrorHandler } from '@mews-commander/ui';
import { Typography } from '@optimus-web/core';
import { ModalSidePanel } from '../../../../components';
import { EnterprisesProductContextProvider } from '../../context/EnterprisesProductContext';
import { useGetCentralProductDetail } from '../../queries/CentralProductsTable';
import { ProductSidePanelTabValues } from '../tables/CentralProductTable/types';
import { CentralProductSidePanelActions } from './CentralProductSidePanelActions';
import { CentralProductSidePanelTabs } from './CentralProductSidePanelTabs';

interface ProductsSidePanelProps {
    centralProductId?: string;
    assignedPropertyIds: string[];
    closeSidePanel: () => void;
    initialTab: ProductSidePanelTabValues;
}

export const CentralProductSidePanel = ({
    centralProductId,
    closeSidePanel,
    initialTab,
    assignedPropertyIds,
}: ProductsSidePanelProps) => {
    const { data, isFetching, isError } = useGetCentralProductDetail(centralProductId);

    const title = (
        <Typography textStyle="titleMediumStrong" wordBreak="break-all" overflowWrap="break-word" as="div">
            {data?.name}
        </Typography>
    );

    const content = data ? (
        <CentralProductSidePanelTabs
            assignedPropertyIds={assignedPropertyIds}
            selectedProduct={data}
            initialTab={initialTab}
        />
    ) : null;

    return (
        <EnterprisesProductContextProvider>
            <ModalSidePanel
                opened={!!centralProductId}
                loading={isFetching}
                title={title}
                onClose={closeSidePanel}
                content={isError ? <DefaultErrorHandler /> : content}
                width="medium"
                headerActions={
                    <CentralProductSidePanelActions
                        id={centralProductId ?? ''}
                        assignedPropertyIds={assignedPropertyIds ?? []}
                        closeSidePanel={closeSidePanel}
                    />
                }
            />
        </EnterprisesProductContextProvider>
    );
};
